import { update } from "lodash";

export default {
  updateUserId(state, payload) {
    if (!payload) return;
    state.User = payload;
    state.UserId = payload.userId;
    localStorage.setItem("userId", state.UserId);
  },

  updateUserLogin(state, payload) {
    if (!payload) return;
    state.User = { UserName: payload.UserName };
    localStorage.setItem("Jwt", payload.access_token);
  },

  updateStatisticInfo(state, payload) {
    state.StatisticInfo = payload;
  },

  updateUserProfile(state, payload) {
    state.UserProfile = payload;
  },

  updateResources(state, payload) {
    if (!payload || payload.length <= 0) return;

    const transformedData = Object.values(
      payload.reduce((acc, item) => {
        const { resourceCode, resourceName, tenantId } = item.resource;

        // Nếu chưa tồn tại resourceCode thì tạo mới
        if (!acc[resourceCode]) {
          acc[resourceCode] = {
            resourceCode,
            resourceName,
            tenantId,
          };
        }

        // Thêm dữ liệu theo scope
        acc[resourceCode][item.scope] = { ...item };

        return acc;
      }, {})
    );
    state.Resources = transformedData;
  },

  updateResourcesByScope(state, payload) {
    if (!payload || payload.length <= 0) return;

    let resources = state.Resources;
    if (!resources || resources.length <= 0) return;

    resources.forEach((resource) => {
      const scopes = payload.filter((item) => item.resourceCode === resource.resourceCode);
      if (scopes && scopes.length > 0) {
        scopes.forEach((scope) => {
          if (scope.scope == 'create') {
            resource.isCreate = true;
          } else if (scope.scope == 'update') {
            resource.isUpdate = true;
          } else if (scope.scope == 'delete') {
            resource.isDelete = true;
          } else if (scope.scope == 'search') {
            resource.isSearch = true;
          } else if (scope.scope == 'list') {
            resource.isList = true;
          }
        });
      }
    });
  },
};
